import type { Letters } from '@/domain/scoring';
import { colorForPlayer } from '@/utils/colorForPlayer';
import { Avatar } from '@/components/ui/Avatar';
import { HiWord } from './HiWord';
import styles from './StandingCard.module.css';

interface WordEntry {
  word: string;
  rawScore: number;
  isUnique: boolean;
  speedBonus: number;
  finalScore: number;
}

interface Props {
  rank: number;
  playerId: string;
  nickname: string;
  totalScore: number;
  words: WordEntry[];
  letters: Letters | undefined;
  isMe: boolean;
  delay: number;
  showUnique?: boolean;
  noWordsCaption?: string;
  // TODO(D12-03): set true when RoundResultPlayerDto gains hasLeft/isConnected from backend
  hasLeft?: boolean;
}

export function StandingCard({
  rank,
  playerId,
  nickname,
  totalScore,
  words,
  letters,
  isMe,
  delay,
  showUnique = true,
  noWordsCaption,
  hasLeft = false,
}: Props) {
  return (
    <div
      className={`${styles.card}${isMe ? ` ${styles.cardMe}` : ''}${hasLeft ? ` ${styles.cardLeft}` : ''}`}
      style={{ animationDelay: `${delay}s` }}
    >
      <div className={styles.header}>
        <span className={styles.rank}>{rank}</span>
        <Avatar name={nickname} color={colorForPlayer(playerId)} size={36} />
        <span className={styles.name}>
          {nickname}
          {isMe && <span className={styles.meBadge}>(вы)</span>}
        </span>
        <span className={styles.score}>{totalScore}</span>
      </div>

      <div className={styles.chips}>
        {words.length === 0 ? (
          <span className={`${styles.noWords}${noWordsCaption ? ` ${styles.noWordsCaption}` : ''}`}>
            {noWordsCaption ?? '—'}
          </span>
        ) : (
          words.map((w, i) => (
            <div key={i} className={styles.chip}>
              <HiWord word={w.word} letters={letters} />
              <span className={styles.rawScore}>{w.rawScore}</span>
              {showUnique && w.isUnique && (
                <span className={styles.uniqueChip}>×2</span>
              )}
              {w.speedBonus > 0 && (
                <span className={styles.speedBonus}>+{w.speedBonus}</span>
              )}
            </div>
          ))
        )}
      </div>
    </div>
  );
}
